import {
    Layers3,
    PencilLine,
    Trash2
} from "lucide-react";

export default function ProcedureCard({

    procedure,

    onEdit,

    onDelete

}) {

    return (

        <div

            style={{

                display: "flex",

                justifyContent: "space-between",

                alignItems: "center",

                padding: "14px 18px",

                borderRadius: 14,

                border: "1px solid #e5e7eb",

                background: "#fff",

                transition: "all .18s ease",

                boxShadow: "0 1px 2px rgba(0,0,0,.04)"

            }}

            onMouseEnter={(e)=>{

                e.currentTarget.style.borderColor="#cbd5e1";
                e.currentTarget.style.boxShadow="0 6px 18px rgba(0,0,0,.08)";

            }}

            onMouseLeave={(e)=>{

                e.currentTarget.style.borderColor="#e5e7eb";
                e.currentTarget.style.boxShadow="0 1px 2px rgba(0,0,0,.04)";

            }}

        >

            <div

                style={{

                    display:"flex",

                    alignItems:"center",

                    gap:12

                }}

            >

                <Layers3

                    size={17}

                    color="#64748b"

                />

                <div>

                    <div

                        style={{

                            fontWeight:600,

                            color:"#0f172a"

                        }}

                    >

                        {procedure.name}

                    </div>

                    <div

                        style={{

                            display:"flex",

                            gap:8,

                            marginTop:6,

                            flexWrap:"wrap"

                        }}

                    >

                        {

                            procedure.requiresOdontogram && (

                                <span

                                    style={{

                                        background:"#dbeafe",

                                        color:"#1d4ed8",

                                        padding:"2px 8px",

                                        borderRadius:999,

                                        fontSize:12,

                                        fontWeight:600

                                    }}

                                >

                                    Odontograma

                                </span>

                            )

                        }

                        {

                            procedure.allowsSurfaces && (

                                <span

                                    style={{

                                        background:"#dcfce7",

                                        color:"#15803d",

                                        padding:"2px 8px",

                                        borderRadius:999,

                                        fontSize:12,

                                        fontWeight:600

                                    }}

                                >

                                    Superficies

                                </span>

                            )

                        }

                    </div>

                </div>

            </div>

            <div

                style={{

                    display:"flex",

                    gap:8

                }}

            >

                <button

                    onClick={()=>onEdit(procedure)}

                    style={{

                        width:38,

                        height:38,

                        borderRadius:10,

                        border:"1px solid #dbe2ea",

                        background:"#fff",

                        cursor:"pointer",

                        display:"flex",

                        justifyContent:"center",

                        alignItems:"center"

                    }}

                >

                    <PencilLine size={17}/>

                </button>

                <button

                    onClick={()=>onDelete(procedure)}

                    style={{

                        width:38,

                        height:38,

                        borderRadius:10,

                        border:"1px solid #fecaca",

                        background:"#fff",

                        color:"#dc2626",

                        cursor:"pointer",

                        display:"flex",

                        justifyContent:"center",

                        alignItems:"center"

                    }}

                >

                    <Trash2 size={17}/>

                </button>

            </div>

        </div>

    );

}